import { forwardRef } from 'react';
import { MenuItem } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useStyles } from './useStyles';

export const FieldSelectMenuItem = forwardRef(
  ({ className, classes, selected, ...restProps }, ref) => {
    const styles = useStyles({ classes });

    return (
      <MenuItem
        className={cx(styles.root, className, {
          [styles.selected]: selected,
        })}
        ref={ref}
        {...restProps}
      />
    );
  }
);

FieldSelectMenuItem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({ selected: PropTypes.string }),
  selected: PropTypes.bool,
};

FieldSelectMenuItem.defaultProps = {
  className: null,
  classes: null,
  selected: false,
};
